import Link from 'next/link';
import {useRouter} from 'next/router';
import PropTypes from 'prop-types';

import useIsMobile from '@/src/hooks/useIsMobile';
import useRoutePaths from '@/src/hooks/useRoutePaths';

import {PreviewImageVideo, Text} from '../../../ui';
import css from '../../styles/TopicDetails.module.css';

const TopicDetails = ({
  videoPreview,
  videoTitle,
  videDuration,
  contentCreator,
  id,
}) => {
  const {
    query: {slug},
  } = useRouter();
  const {WATCH_COURSE_ROUTE} = useRoutePaths();
  const {isMaxWidth600} = useIsMobile();

  return (
    <Link
      href={{
        // @ts-ignore
        pathname: WATCH_COURSE_ROUTE.getLink(slug),
        query: {video_id: id},
      }}
    >
      <a>
        <div className={css.videoWrapper}>
          <div className={css.videoPreviewImage}>
            <PreviewImageVideo image={videoPreview} />
          </div>
          <div className={css.contentCreator}>
            <Text
              isOneLine
              color={Text.COLOR.GREY}
              fontSize={
                isMaxWidth600 ? Text.FONT_SIZE.SIZE_12 : Text.FONT_SIZE.SIZE_14
              }
              fontWeight={Text.FONT_WEIGHT.MEDIUM}
              lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
            >
              {contentCreator}
            </Text>
          </div>
          <div className={css.title}>
            <Text
              fontSize={
                isMaxWidth600 ? Text.FONT_SIZE.SIZE_12 : Text.FONT_SIZE.SIZE_16
              }
              fontWeight={Text.FONT_WEIGHT.BOLD}
              lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
            >
              {videoTitle}
            </Text>
          </div>

          <div className={css.videoDuration}>
            <Text
              fontSize={
                isMaxWidth600 ? Text.FONT_SIZE.SIZE_12 : Text.FONT_SIZE.SIZE_14
              }
              color={Text.COLOR.GREY}
            >
              {videDuration}
            </Text>
          </div>
        </div>
      </a>
    </Link>
  );
};

TopicDetails.propTypes = {
  videoPreview: PropTypes.string.isRequired,
  videoTitle: PropTypes.string.isRequired,
  videDuration: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  contentCreator: PropTypes.string.isRequired,
};

export default TopicDetails;
